import {
	Container, Box,
	Typography, Paper,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { SiteRouterLink } from "../../components/RouterLink";
import { HaohanH1 } from "../../components/HaohanH1";
import { useI18n } from "../locales";

const useStyles = makeStyles()(() => ({
	main: {
		
	},
	logo: {
		display: "block",
		//margin: "0 auto 24px",
		width: 48,
	}
}))


export function SiteAuthHeader() {
	const { classes } = useStyles();
	const { lang, t } = useI18n();
	return (
		<header>
			<Container sx={{maxWidth: "md"}}>
				<Box display="flex" alignItems='center' py={.5}>
					<HaohanH1 lang={lang} />
					<Box sx={{display: {xs: 'none', sm: 'block'}}} ml={9} mt={.7} textAlign='center'>
						<Typography color='textSecondary' variant="h6" gutterBottom={false}>
							{t('Account management')}
						</Typography>
					</Box>
				</Box>
			</Container>
		</header>
	);
}